<template>
    <div class="order-detail-section mg20">
        <h3>业绩信息</h3>
        <el-table :data="test" border style="margin:20px; width:97%">
            <el-table-column label="修订项" prop="title">
                <template slot-scope="scope">
                    {{scope.row.title}}
                </template>
            </el-table-column>
            <el-table-column label="修订后内容"  prop="ccc">
                <template slot-scope="scope">
                    <span v-html=scope.row.new_content></span>
                </template>
            </el-table-column>
            <el-table-column label="原内容" prop="bbb">
                <template slot-scope="scope" >
                    <span v-html=scope.row.old_content></span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import {OrderMixin} from "~/services/OrderMixin";
    export default {
        name: "performance",
        mixins: [OrderMixin],
        props: {
            order: {
                required: true
            },
            oldOrder: {
                required: false
            }
        },
        watch: {
            order(v, s) {
                if(this.order.content){
                    const user = this.order.content.cooperator ? this.order.content.cooperator : this.order.content.user;
                    const old_user = this.order.before_content.cooperator ? this.order.before_content.cooperator : this.order.before_content.user;
                    // if(this.$route.query['flow_type'] == this.params.CONTRACT_LINE){
                    //     this.order.content.cooperator = this.order.order_detail.finance.sale_user;
                    // }
                    this.test = this.test.map(item=> {
                        if (item.field == 'main') {
                            let main = user.find(i=>{
                                return i.is_cooperator==0;
                            });
                            let mail_sale = "销售人："+main.name+"<br/>";
                            let mail_money = "业绩金额："+main.pfm_amount+"<br/>";
                            let mail_renew = "续费金额："+main.renew_amount+"<br/>";

                            let old = old_user.find(i=>{
                                return i.is_cooperator==0;
                            });
                            let old_sale = "销售人："+old.name+"<br/>";
                            let old_money = "业绩金额："+old.pfm_amount+"<br/>";
                            let old_renew = "续费金额："+old.renew_amount;

                            if(mail_sale != old_sale ){
                                mail_sale = this.markRed(mail_sale);
                            }
                            if(mail_money != old_money){
                                mail_money = this.markRed(mail_money);
                            }
                            if(mail_renew != old_renew){
                                mail_renew = this.markRed(mail_renew);
                            }
                            item.new_content = mail_sale+mail_money+mail_renew;
                            item.old_content = old_sale+old_money+old_renew;
                        }
                        if (item.field == 'minor') {
                            let minor = user.filter(i=>{
                                return i.is_cooperator==1;
                            });
                            if(minor.length>0){
                                let content = '';
                                let old_content = '';
                                minor.forEach(i=>{
                                    let minor_sale = "协作人："+i.name+"&nbsp;&nbsp;";
                                    let minor_money = "业绩金额："+i.pfm_amount+"&nbsp;&nbsp;";
                                    let minor_renew = "&nbsp;&nbsp;续费金额："+i.renew_amount;
                                    let new_content = minor_sale+minor_money+minor_renew+"<br/>";

                                    let old = old_user.find(u=>{
                                        return u.user_id == i.user_id && u.is_cooperator == 1;
                                    })
                                    if(old){
                                        let minor_cp_sale = "协作人："+i.name+"&nbsp;&nbsp;";
                                        let minor_cp_money = "业绩金额："+i.pfm_amount+"&nbsp;&nbsp;";
                                        let minor_cp_renew = minor_cp_renew = "&nbsp;&nbsp;续费金额："+old.renew_amount;
                                        if(minor_sale != minor_cp_sale){
                                            minor_sale = this.markRed(minor_sale);
                                        }
                                        if(minor_money != minor_cp_money){
                                            minor_money = this.markRed(minor_money);
                                        }
                                        if(minor_renew != minor_cp_renew){
                                            minor_renew = this.markRed(minor_renew);
                                        }
                                        new_content = minor_sale+minor_money+minor_renew+"<br/>";
                                        let cp_content = minor_cp_sale+minor_cp_money+minor_cp_renew+"<br/>";
                                        old_content += cp_content;
                                    }else{ //没有旧的就是新增需要标红
                                       new_content = this.markRed(new_content)
                                    }
                                    content += new_content;
                                })
                                item.new_content = content;
                                item.old_content = old_content;
                            }
                        }
                        return item;
                    });
                }
            }
        },
        mounted() {
            let params = {
                fields: 'id,name',
                scenario: 'all-user'
            };
        },
        data() {
            return {
                test:[
                    {
                        field:'main',
                        title:'订单负责人',
                        new_content:'',
                        old_content:'',
                    },
                    {
                        field:'minor',
                        title:'订单协作人',
                        new_content:'',
                        old_content:'',
                    }
                ]
            }
        },
        methods:{
            markRed(v){
                return '<span style="color: red">'+v+'</span>';
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/order/finance/performance.vue